// KissFresh cart cross-sell ("Hozzáadom") — loaded by the cart drawer and the cart page.
class KfCartUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
    this.addEventListener('change', this.onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('change', this.onChange);
  }

  onClick = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const step = target.closest('[data-kf-qty-step]');
    if (step) {
      this.setQuantity(this.quantity + Number(step.dataset.kfQtyStep));
      return;
    }
    const button = target.closest('[data-kf-upsell-add]');
    if (button && !button.disabled) this.add(button);
  };

  onChange = (event) => {
    if (event.target instanceof HTMLInputElement && event.target.matches('[data-kf-qty-input]')) {
      this.setQuantity(Number(event.target.value));
    }
  };

  get quantity() {
    const input = this.querySelector('[data-kf-qty-input]');
    return Math.max(1, Math.floor(Number(input && input.value) || 1));
  }

  setQuantity(value) {
    const input = this.querySelector('[data-kf-qty-input]');
    if (!input) return;
    const max = Number(input.max) || 20;
    const quantity = Math.min(max, Math.max(1, Math.floor(Number(value) || 1)));
    input.value = String(quantity);
    const minus = this.querySelector('[data-kf-qty-step="-1"]');
    const plus = this.querySelector('[data-kf-qty-step="1"]');
    if (minus) minus.disabled = quantity <= 1;
    if (plus) plus.disabled = quantity >= max;
  }

  async add(button) {
    const error = this.querySelector('.kf-upsell__error');
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const variantId = Number(this.dataset.variantId);
    const quantity = this.quantity;
    const sectionIds = Array.from(
      new Set(
        Array.from(document.querySelectorAll('cart-items-component[data-section-id]'), (el) => el.dataset.sectionId)
      )
    );

    button.disabled = true;
    this.classList.add('is-loading');
    if (error) error.hidden = true;
    // Safety net: if the in-place refresh does not happen, reload the page so the cart is always correct
    let added = false;
    const fallback = setTimeout(() => {
      if (added && this.isConnected) window.location.reload();
    }, 6000);

    // Use the theme's cart event so the cart page / drawer and the cart bubble refresh in place
    let CartEvent = null;
    try {
      CartEvent = (await import('@shopify/events')).CartLinesUpdateEvent || null;
    } catch (e) {
      CartEvent = null;
    }
    const deferred = CartEvent ? CartEvent.createPromise() : null;
    if (deferred) {
      this.dispatchEvent(
        new CartEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(variantId), quantity }],
          promise: deferred.promise,
        })
      );
    }

    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity }], sections: sectionIds.join(',') }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Add to cart failed');
      added = true;

      if (!deferred) {
        window.location.reload();
        return;
      }
      const cartUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || root + 'cart';
      const cart = await fetch(cartUrl + '.json').then((r) => r.json());
      deferred.resolve({
        cart: CartEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'kf-cart-upsell',
          itemCount: quantity,
          sections: data.sections,
          didError: false,
        },
      });
    } catch (err) {
      if (added) {
        window.location.reload();
        return;
      }
      clearTimeout(fallback);
      if (deferred) deferred.reject(err);
      if (error) {
        error.textContent = (err && err.message) || 'Hiba történt, próbáld újra.';
        error.hidden = false;
      }
      button.disabled = false;
      this.classList.remove('is-loading');
    }
  }
}

if (!customElements.get('kf-cart-upsell')) customElements.define('kf-cart-upsell', KfCartUpsell);
